import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { env } from "../utils/env";
import { useAuth } from "../context/AuthContext";

interface Params {
  id: number;
  data: {
    _form?: number[];
    additional_document?: number[];
  };
}

export const useAddExtraAction = () => {
  const { authHeader } = useAuth();

  return useMutation((params: Params) => {
    return axios.post(
      `${env.verifyServiceUrl}individual/individual_v2/${params.id}/add_extra_action/`,
      params.data,
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
